module.exports = __webpack_public_path__ + "static/media/slider-3.4e54f761.jpg";